module.exports = __webpack_public_path__ + "static/img/Horticulturae 09.1d10896f.webp";